/* Tools results, keyed by application. Lifted out of local state so the chat panel —
   same tree under AppShell — can drive the page in place. `origin` ('page' | 'agent')
   records which engine produced the numbers. */
import { createSlice } from '@reduxjs/toolkit';

const emptyEntry = () => ({
  comparison: null,
  amortization: null,
  origin: null,
  updatedAt: null,
});

const entryFor = (state, applicationId) => {
  if (!state.byApplication[applicationId]) {
    state.byApplication[applicationId] = emptyEntry();
  }
  return state.byApplication[applicationId];
};

const loanTools = createSlice({
  name: 'loanTools',
  initialState: {
    byApplication: {},
  },
  reducers: {
    comparisonReceived: (state, action) => {
      const { applicationId, payload, origin = 'page' } = action.payload || {};
      if (!applicationId) return;
      const entry = entryFor(state, applicationId);
      entry.comparison = payload;
      entry.origin = origin;
      entry.updatedAt = action.payload.receivedAt || null;
    },
    amortizationReceived: (state, action) => {
      const { applicationId, payload, origin = 'page' } = action.payload || {};
      if (!applicationId) return;
      const entry = entryFor(state, applicationId);
      entry.amortization = payload;
      entry.origin = origin;
      entry.updatedAt = action.payload.receivedAt || null;
    },
    toolsCleared: (state, action) => {
      const applicationId = action.payload?.applicationId;
      if (applicationId) {
        delete state.byApplication[applicationId];
      } else {
        state.byApplication = {};
      }
    },
  },
});

export const { comparisonReceived, amortizationReceived, toolsCleared } = loanTools.actions;

const NO_ENTRY = emptyEntry();
const entrySelector = (state, applicationId) =>
  state.loanTools?.byApplication?.[applicationId] || NO_ENTRY;

export const selectToolsEntry = entrySelector;
export const selectComparison = (state, applicationId) => entrySelector(state, applicationId).comparison;
export const selectAmortization = (state, applicationId) => entrySelector(state, applicationId).amortization;
export const selectToolsOrigin = (state, applicationId) => entrySelector(state, applicationId).origin;

export default loanTools.reducer;
